import React, { useEffect, useState } from "react";

import { Grid } from "../../components/Grid.components";
import { Boxed } from "../../components/Boxed.components";
import { PageTitle } from "../../components/style";
import { Text, LabelText } from "../../components/Text.components";

import { Theme } from "../../utils/theme";
import { AsyncSelect, Input, Label } from "../../components/Input.components";

import LOGIN_BG from "../../assets/img/gis-landing.png";
import { formatDate } from "../../utils/utils";
import { Loader } from "../../components/Loader.components";
import { Uploader } from "../../components/Uploader.components";
import { Button } from "../../components/Button.components";

export const Profile = (props) => {
  // State props
  const { profile, callCodesList, isLoadingCallCodes } = props;

  // Dispatch props
  const { form, editUser, redirect, fetchAllUserTypes, fetchCallCodes } = props;
  const { getFieldProps, getFieldError, validateFields, getFieldValue } = form;
  const [profileImage, setProfileImage] = useState("");

  const [showUploader, setShowUploader] = useState(false);
  useEffect(() => {
    fetchAllUserTypes();
    fetchCallCodes();
  }, []);

  const addImage = (e) => {
    const base64Image = `data:${e.type};base64,${e.base64}`;
    setProfileImage(base64Image);
    setShowUploader(false);
  };

  console.log(profile);
  const onSubmit = () => {
    validateFields((error, value) => {
      if (!error) {
        const payload = {
          firstName: value.firstname.trim(),
          lastName: value.lastname.trim(),
          phoneNumber: {
            countryCode:
              value.callCode.value ?? profile?.phoneNumber?.countryCode,
            phone: value.phone.trim(),
          },
          profilePictureUrl: profileImage || profile?.profilePictureUrl,
        };
        // console.log(payload)
        editUser({ data: payload, id: profile?._id });
      }
    });
  };
  return (
    <Boxed pad="30px">
      <Boxed display="flex" alignItems="center" justifyContent="space-between">
        <PageTitle margin="5px 0">
          Profile / {profile?.lastName} {profile?.firstName}{" "}
        </PageTitle>
        <i className="icon-cancel" onClick={() => redirect("/dashboard")} />
      </Boxed>

      {!showUploader && (
        <Boxed
          margin="10px auto"
          display="flex"
          flexDirection="column"
          alignItems="center"
          position="relative"
        >
          <img
            src={profileImage || profile?.profilePictureUrl}
            alt="profile"
            style={{ width: "160px", height: "160px", borderRadius: "9999px" }}
          />
          <Boxed
            bColor="#ffff"
            pad="5px 8px"
            borderRadius="9999px"
            position="absolute"
            bottom="24px"
            onClick={() => setShowUploader(true)}
          >
            <i className="icon-edit-2" style={{ fontSize: "22px" }} />
          </Boxed>
        </Boxed>
      )}

      <Boxed
        margin="10px auto"
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
      >
        <Button onClick={onSubmit}>Save</Button>
      </Boxed>

      {showUploader && (
        <Boxed margin="15px">
          <Text fontWeight={800}>Add Profile Image</Text>
          <Uploader
            types={["image/png", "image/jpeg"]}
            message={"Click to add a profile image"}
            callBack={addImage}
          />
        </Boxed>
      )}
      <Grid
        desktop="repeat(2, 1fr)"
        tablet="repeat(2, 1fr)"
        mobile="repeat(1,1fr)"
        pad="0 0 30px 0"
      >
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="First Name"
            placeholder="Enter first name..."
            error={getFieldError("firstname") ? "First name is required" : null}
            {...getFieldProps("firstname", {
              initialValue: profile?.firstName,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Last Name"
            placeholder="Enter last name..."
            error={getFieldError("lastname") ? "Last name is required" : null}
            {...getFieldProps("lastname", {
              initialValue: profile?.lastName,
              rules: [{ required: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Email"
            placeholder="Enter email..."
            disabled
            error={getFieldError("email") ? "Email is required" : null}
            {...getFieldProps("email", {
              initialValue: profile?.email,
              rules: [{ required: true, email: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Phone Number"
            // width={"85%"}
            placeholder="Enter phone number..."
            error={getFieldError("phone") ? "Phone number is required" : null}
            {...getFieldProps("phone", {
              initialValue: profile?.phoneNumber?.phone,
              rules: [{ required: true }],
            })}
          />
        </Boxed>

        <Boxed pad="10px 0">
          <AsyncSelect
            label="Country of Residence"
            placeholder=""
            isLoading={isLoadingCallCodes}
            options={
              callCodesList?.map((item) => ({
                label: `${item?.code} ${item?.dial_code}`,
                value: item?.dial_code,
              })) ?? []
            }
            error={getFieldError("callCode") ? "call code is required" : null}
            {...getFieldProps("callCode", {
              initialValue: profile?.phoneNumber?.countryCode,
              rules: [{ required: true }],
            })}
          />
        </Boxed>
        <Boxed pad="10px 0">
          <Input
            type="text"
            label="Date"
            disabled
            placeholder="Enter phone number..."
            error={
              getFieldError("createdDate") ? "Phone number is required" : null
            }
            {...getFieldProps("createdDate", {
              initialValue: profile?.createdAt.slice(0, 10),
              rules: [{ required: true }],
            })}
          />
        </Boxed>
      </Grid>
    </Boxed>
  );
};
